<tellent-assistant-brand-mark class="mark" [size]="16" />
<span class="label">{{ label() }}</span>
